import { http } from "@/helpers/http";
import APP_URL from "@/helpers/urls";
const baseUrl = APP_URL("core-v2");

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},

    actions: {
        fetchCustomers({ state, commit, rootState }, payload) {
            http.get(`${baseUrl}/customers?afterKey=${payload.afterKey || ''}&column=${payload.searchConfig.column}&keyword=${payload.searchConfig.keyword}`).then(response => {
                if (payload.callback) payload.callback(true, response.data);
            }).catch(error => {
                console.log(error);
                if (payload.callback) payload.callback(false);
            })
        },

        searchCustomers({ state, commit, rootState }, payload) {
            http.get(`${baseUrl}/customers/search?column=${payload.column}&keyword=${payload.keyword}`).then(response => {
                if (payload.callback) payload.callback(true, response.data);
            }).catch(error => {
                console.log(error);
                if (payload.callback) payload.callback(false);
            })
        },
    }
}